export const createColourFromString = (str: string) => {
  let hash = 0;
  str.split("").forEach((char) => {
    hash = char.charCodeAt(0) + ((hash << 5) - hash);
  });

  let colour = "#";
  const brightnessFactor = 0.6; // scale down to make the color darker

  for (let i = 0; i < 3; i++) {
    let value = (hash >> (i * 8)) & 0xff;
    value = Math.floor(value * brightnessFactor); // darken the color
    colour += value.toString(16).padStart(2, "0");
  }

  return colour;
};
